import type { PageNumber, SinglePagePdf } from "@pdfking/pdfengine"
import { Items, Keys, RecordCreate, SortBy } from "@pdfking/tfunc"

import type { FileCollectionStore } from "#public"
import type { FileCtx } from "#public"
import type { ResultContext } from "#public"

/**
 * The field context both form panels build (ImpositionForm for the imposition
 * fields, FileRows for the file rows): everything the custom file controllers
 * (FileRange's page count, FileScale's preview geometry, FileDestination's
 * allowed set) read off the viewer. Call it inside a computed — it reads the
 * store's and the result's reactive state, so the caller tracks them.
 */
export const BuildFileCtx = ({
  view,
  hidden_fields,
  staff,
  store,
}: {
  view: ResultContext | undefined
  hidden_fields: string[]
  staff: boolean
  store: FileCollectionStore
}): FileCtx => ({
  // First page per file — the scale/range fields' preview source.
  file_media: RecordCreate(
    Items(store.files)
      .map(([name, entry]) => [name, entry.pages[1 as PageNumber]] as const)
      .filter((pair): pair is [string, SinglePagePdf] => !!pair[1])
  ),
  file_options: () =>
    SortBy(Keys(store.files)).map((name: string) => [name, name] as [string, string]),
  file_destinations: view?.file_destinations ?? new Set(),
  guides: view?.guides ?? [],
  hidden_fields,
  sample_media: view?.sample_media,
  staff,
})
